import type { Article } from "./types";

export const ARTICLES: Article[] = [
  {
    slug: "hongtan-de-shi-miao-zhong",
    title: "红毯那十秒钟：站姿是提前两周就排好的",
    excerpt:
      "在镜头拍不到的地方，红毯其实是一场分工明确的团队作业。走位、眼神、落脚点，早在两周前就写进了流程单。",
    category: "yenei",
    sourceRole: "业内执行统筹",
    date: "2026-09-09",
    readTime: "7 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Red%20carpet%20event%20side%20corridor%20with%20warm%20glowing%20spotlights%20and%20cream%20marble%20backdrop%2C%20empty%20stage%20with%20lighting%20stands%2C%20editorial%20event%20photography%2C%20warm%20golden%20and%20paper%20tones%2C%20moody%20cinematic%20atmosphere%2C%20no%20identifiable%20faces&width=1200&height=800&seq=art-redcarpet&orientation=landscape",
    tags: ["红毯", "活动执行", "排面"],
    views: 183426,
    likes: 12048,
    hot: true,
    featured: true,
    blocks: [
      { type: "p", text: "很多人以为红毯就是明星走上去、媒体按下快门那几十秒的事。但在业内人眼里，真正的红毯，从选址前一个月就已经开始了。我今天聊的这场，是圈内很常见的一场时尚晚宴红毯，作为执行统筹，我从候选名单定下来的那天起，就开始一项项对表。" },
      { type: "h", text: "走位单：比剧本更像剧本" },
      { type: "p", text: "明星的红毯走位，不是临场发挥的。流程单上会精确到「第几分钟到候场区、从哪一侧入场、在背板前停留多久、朝哪个机位微笑」。所谓排面，其实就是把每一步都算得刚刚好，让镜头看起来从容又随性。真正的高手，会把「看似偶然的停顿」也提前排好。" },
      { type: "quote", text: "镜头前的松弛，往往是背板后最紧张的一种准备。没有谁是天生的「临场发挥型选手」，只是你看到的偶然，都是被排练过很多次的必然。", cite: "一位从业十二年的活动执行统筹" },
      { type: "p", text: "有次一位初次走这种大场子的新人，提前两天被我拉着在酒店走廊里来回练「转身到背板前、留三秒、再看向镜头」这组动作。他不理解为什么要练走路，我说你练的不是走路，是让所有机位都追得上你的节奏。真正到了现场，音乐一响，他自然就被带进了节奏里。" },
      { type: "h", text: "镜头之外的工序" },
      { type: "p", text: "再往细了说，候场区、补妆位、媒体动线、安保站位，每一样都关系到最后呈现在照片里的那几秒。我们最怕的不是现场乱，而是「媒体没拍到该拍的人」。所以排布的时候，得让每一个嘉宾都能被主镜头照顾到，顺序、站位、停留时间都要反复微调。业内管这个叫「一碗水端平」，其实挺贴切。" },
      { type: "tip", text: "下次看到红毯图，不妨留意明星第一次看向镜头的位置和停留的秒数——那多半不是巧合，而是流程单上的一个坐标。" },
    ],
  },
  {
    slug: "penfan-biao-shang-de-jiangjiu",
    title: "剧组盒饭里，最讲究的不是味道",
    excerpt:
      "几百号人的午饭，是一场移动的物流。谁先吃、在哪吃、剩多少，处处藏着剧组的秩序与人情。",
    category: "juzu",
    sourceRole: "现场制片助理",
    date: "2026-09-08",
    readTime: "6 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Outdoor%20film%20crew%20catering%20tables%20under%20a%20big%20tent%20with%20warm%20afternoon%20light%2C%20stacked%20lunchboxes%20and%20thermos%2C%20crew%20members%20in%20silhouette%20taking%20food%2C%20candid%20documentary%20photography%2C%20warm%20amber%20and%20cream%20tones%2C%20no%20identifiable%20faces&width=1200&height=800&seq=art-boxlunch&orientation=landscape",
    tags: ["剧组", "盒饭", "现场秩序"],
    views: 97215,
    likes: 8341,
    hot: false,
    featured: false,
    blocks: [
      { type: "p", text: "在组里干得久了，我学会的第一件事不是打板，而是认盒饭。每天开饭前，现场制片会按工种先排一轮顺序：主演和导演优先，摄影、灯光这些「手不能停」的部门紧随其后，最后才是收尾的场务。这个顺序不是讲究，是没办法——机器一停，每分钟都是钱。" },
      { type: "p", text: "天热的时候最难办。盒饭在保温箱里放久了会捂馊，放太早又怕凉。负责订餐的同事手机里存着好几个片场的备用电话，就怕今天这场拍得久、餐送不上来。很多人以为剧组吃得好不好看预算，其实更看统筹。预算再足，送餐不及时，照样有人饿着肚子等下一场。" },
      { type: "quote", text: "一个组靠不靠谱，看它怎么安排盒饭就知道了。能把几百号人的饭按时按量摆明白的，往往也能把一场戏调度明白。", cite: "跟组多年的外联制片" },
      { type: "p", text: "当然也有暖心的时候。有次大夜戏拍到凌晨，制片组偷偷加订了热汤，说先给收尾的小姑娘们盛。那一刻我忽然觉得，圈子里传的那些勾心斗角是存在的，可多数普通工作人员，每天想的其实就是把这一场拍完、把这顿饭吃热。明星八卦之外，这才是剧组生活最真实的样子。" },
    ],
  },
  {
    slug: "daye-xi-de-biao",
    title: "凌晨三点的大夜戏，场务手里那张表说了算",
    excerpt:
      "大夜戏拍的不是演技，是调度。场务的那张时间表上，每个小时都写着成本，也写着很多人的疲惫与坚持。",
    category: "juzu",
    sourceRole: "副导演",
    date: "2026-09-07",
    readTime: "8 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Night%20time%20film%20set%20lit%20by%20large%20warm%20practical%20lamps%20and%20city%20glow%20in%20background%2C%20crew%20silhouettes%20with%20clipboards%2C%20candid%20documentary%20photography%2C%20warm%20amber%20night%20tones%20against%20deep%20warm%20shadows%2C%20atmospheric%2C%20no%20identifiable%20faces&width=1200&height=800&seq=art-night&orientation=landscape",
    tags: ["大夜戏", "副导演", "调度"],
    views: 61102,
    likes: 5033,
    hot: false,
    featured: false,
    blocks: [
      { type: "p", text: "大夜戏是剧组里最磨人的环节之一。凌晨两三点是人最困的时候，可机器和灯光却必须保持满血。这时候真正在运转的，其实是场务和副导演手里的那张表——几点放饭、几点转场、哪个部门先撤，全都写在上面。" },
      { type: "p", text: "有人说拍戏是艺术，可我做了这么多年副导演，越做越觉得它更像一门精确到分钟的手艺。演员情绪到位了，可天快亮了，机位还没转过来，就只能忍痛删戏。你问我们最怕什么？不是演员难搞，是时间不够。时间一到，再精彩的设计也得让路。" },
      { type: "quote", text: "圈内常说「戏是等出来的」，其实更要命的是「戏是被时间赶出来的」。能在大夜戏里把节奏稳住的人，才是现场真正的定海神针。", cite: "一位常年跟大夜戏的统筹" },
      { type: "h", text: "那盏灯，也照着普通人的夜" },
      { type: "p", text: "凌晨三点，灯亮着，人醒着。有人刷手机等下一场，有人靠墙角眯十分钟。说实话，明星八卦里那些光鲜，多半是镜头前的事；镜头外的夜晚，是一群普通人用自己的睡眠，去换观众几秒的感动。这些事没人会写成热搜，但它是圈内人真实经历的一部分。" },
    ],
  },
  {
    slug: "shijing-shi-jixingren-jile",
    title: "试镜室里，经纪人在纸上到底记了什么",
    excerpt:
      "一张A4纸、一支笔，十分钟试镜。经纪人写下的那几行字，往往决定了这个下午之后，谁会接到那个电话。",
    category: "jingji",
    sourceRole: "新人经纪人",
    date: "2026-09-08",
    readTime: "6 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Quiet%20studio%20audition%20room%20with%20warm%20table%20lamp%2C%20clipboard%20and%20pen%20on%20wooden%20table%2C%20empty%20chair%20facing%20a%20camera%20on%20tripod%2C%20editorial%20documentary%20mood%2C%20warm%20amber%20and%20cream%20tones%2C%20soft%20shadows%2C%20no%20people&width=1200&height=800&seq=art-audition&orientation=landscape",
    tags: ["试镜", "经纪人", "选角"],
    views: 88340,
    likes: 6211,
    hot: true,
    featured: false,
    blocks: [
      { type: "p", text: "带艺人去试镜，是经纪人日常工作里最平常也最紧张的一环。外人以为我们只是陪着等、陪着聊，其实那张纸和那支笔，才是重头戏。试镜结束，选角导演看得是表演，我们记的却是另一套东西。" },
      { type: "h", text: "笔下的「四象限」" },
      { type: "p", text: "我习惯把试镜分成四栏：状态、契合度、可塑性、风险点。状态看的是他今天是否在最佳频道；契合度看他跟角色的距离；可塑性看导演有没有进一步调教的可能；风险点则最微妙——台词会不会破音、镜头感是否稳定、临场能不能接住导演丢过来的即兴。" },
      { type: "quote", text: "一场试镜下来，表演是一时的，导演心里记的往往是一张「适合合作」的标签。经纪人要做的，就是帮艺人把这四个字提前写进对方心里。", cite: "带过十多位演员的资深经纪人" },
      { type: "p", text: "有时导演什么都没说，只让艺人「再来一遍」，很多新人会慌。但我见过真正的老演员，会把这句「再来一遍」当成导演给出的信号——他愿意在你身上花时间，本身就是一种机会。这些细节，不会写进任何一篇通稿，却是圈内人每天真实面对的事。" },
      { type: "tip", text: "如果你正在追逐自己的舞台梦，不妨记住：被要求「再来一遍」，通常不是坏消息。" },
    ],
  },
  {
    slug: "bu-neng-fa-pengyouquan-de-he-tong",
    title: "那份「不能发朋友圈」的合同条款",
    excerpt:
      "保密、报备、宣传配合……艺人合同里藏着不少约束条款。经纪人私下常打趣：有些事，只能烂在合同和心里。",
    category: "jingji",
    sourceRole: "商务经纪人",
    date: "2026-09-06",
    readTime: "7 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Overhead%20view%20of%20a%20contract%20document%20with%20seal%20and%20fountain%20pen%20on%20warm%20desk%20beside%20a%20cup%20of%20tea%2C%20warm%20desk%20lamp%20light%2C%20editorial%20flat%20lay%20photography%2C%20amber%20and%20cream%20tones%2C%20subtle%20shadows&width=1200&height=800&seq=art-contract&orientation=landscape",
    tags: ["合同", "保密条款", "商务"],
    views: 70563,
    likes: 4988,
    hot: false,
    featured: false,
    blocks: [
      { type: "p", text: "很多圈内梗，都是从合同聊起来的。比如「不能发朋友圈」，它不是一个段子，而是白纸黑字的保密与宣传条款。艺人接了项目，什么时候能官宣、能透露到什么程度，合同里都写得分明。谁先破了规矩，赔的不是钱，是信誉。" },
      { type: "p", text: "我常跟新人说，合同不是拿来吓人的，是拿来保护双方的。有次合作方想临时加拍，我方艺人档期已经排满，正是靠合同里的排他条款，大家才心平气和地把事谈成了。你越明白规则，越能在谈判桌上占得主动。真正的业内老手，都是「把丑话说在前面」，反而后面相处最体面。" },
      { type: "quote", text: "圈内人吐槽的从来不是合同本身，而是那些想用合同之外的小动作占便宜的人。规则越清楚，江湖反而越干净。", cite: "处理过上百份艺人合约的商务代理" },
      { type: "p", text: "至于那些实在没法写进合同、只能靠口头默契的事，就真的只能「烂在肚子里」了。这种心照不宣，才是圈内八卦里最常被提起、又最没人能说清的部分。明星八卦圈内的水，往往就深在这层没说出口的地方。" },
    ],
  },
  {
    slug: "xin-ren-jingji-de-di-yige-yue",
    title: "带新人的第一个月，经纪人最怕什么",
    excerpt:
      "不是资源不够，也不是艺人难带。带新人的头一个月，最怕的是「节奏错了」——该红的时候接不住，该藏的时候露了怯。",
    category: "jingji",
    sourceRole: "经纪人",
    date: "2026-09-05",
    readTime: "6 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Two%20coffee%20cups%20and%20a%20notebook%20on%20a%20warm%20cafe%20table%20beside%20a%20window%20with%20soft%20morning%20light%2C%20editorial%20conversation%20photography%2C%20warm%20amber%20and%20cream%20tones%2C%20blurred%20background%2C%20no%20clear%20faces&width=1200&height=800&seq=art-newcomer&orientation=landscape",
    tags: ["新人", "经纪人", "成长"],
    views: 54120,
    likes: 4055,
    hot: false,
    featured: false,
    blocks: [
      { type: "p", text: "新签下一位艺人，头一个月是我最不敢放松的时候。外人以为经纪人的烦恼是「资源不够」，其实真正的坎，是把节奏卡对。新人最大的风险，往往不是没人看见，而是被看见得太早、准备得太少。" },
      { type: "p", text: "有经验的经纪人都懂一个词叫「接住」。机会来了，你要能稳稳接住，把它变成下一步的跳板；但同时也得学会「藏」，在还没准备好的领域，少露怯。第一个月我基本不会急着铺资源，而是先摸清艺人的定位、优势和短板，把这套东西跑顺了，后面才敢出手。" },
      { type: "quote", text: "娱乐圈最不缺的就是一夜爆红，缺的是能在一夜爆红之后，依然知道自己是谁的人。带新人，先稳住心，再谈红。", cite: "一位转型幕后的前经纪人" },
      { type: "p", text: "我常常在夜里翻聊天记录复盘：今天哪句话该说而没说，哪个场合该帮而没帮。干这行久了你会明白，所谓明星八卦圈内，热闹是给别人看的，清醒才是留给自己和艺人的。" },
    ],
  },
  {
    slug: "dangqi-biao-de-qi-shi",
    title: "一张档期表，为什么比剧本更能看出谁红",
    excerpt:
      "谁的时间排得满、谁的空窗期最长、谁的档期互相打架……业内人看圈里冷热，很少看热搜，更多看那张档期表。",
    category: "yenei",
    sourceRole: "选角统筹",
    date: "2026-09-04",
    readTime: "7 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Wooden%20desk%20with%20printed%20production%20schedule%20spread%20out%20under%20warm%20desk%20lamp%2C%20calendar%20and%20sticky%20notes%2C%20editorial%20workplace%20photography%2C%20warm%20amber%20and%20cream%20tones%2C%20shallow%20depth%20of%20field%2C%20no%20people&width=1200&height=800&seq=art-schedule&orientation=landscape",
    tags: ["档期", "选角", "行业观察"],
    views: 131207,
    likes: 9560,
    hot: true,
    featured: false,
    blocks: [
      { type: "p", text: "在业内待久了你会发现，判断一个演员「红不红」，热搜和数据都只能做参考，最诚实的其实是档期表。档期排得满，说明市场认可；空窗期太长，多半是在等一个「能把身价抬起来」的本子。这两种状态，心态截然不同。" },
      { type: "h", text: "档期打架的学问" },
      { type: "p", text: "真正有分量的艺人，档期往往不是排不满，而是「不敢排满」。他们会留出时间，去等那个真正配得上自己的项目。所以我选角时最怕遇到的，不是没档期，而是档期「虚」——嘴上答应，实则随时准备为更重要的大项目抽身。圈子不大，这种虚话传得很快。" },
      { type: "quote", text: "粉丝看到的是作品表，业内在意的是档期与片酬的匹配度。一部剧敢不敢把重头戏押在你身上，看的就是你过往每一次「接住」的记录。", cite: "一位平台端的制片人" },
      { type: "p", text: "这张表还能看出圈内很多冷暖。有段时间某位明星忽然档期松下来，业内不是先看新闻，而是先互相打听「是不是有什么情况」。这种无声的雷达，比任何八卦都灵敏。所谓业内观察，看的从来不是表面热闹，而是这些藏在表格与日历里的一手信号。" },
    ],
  },
  {
    slug: "yingshou-zhuo-shang-de-na-ju-zhenhua",
    title: "应酬桌上那句真话，散场后没人认账",
    excerpt:
      "饭局上拍着胸脯应下的事，常被第二天当作玩笑带过。圈内很多「口头承诺」，都只活在那个酒杯满起来的瞬间。",
    category: "zhiqing",
    sourceRole: "知情者",
    date: "2026-09-03",
    readTime: "6 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20dim%20private%20dining%20room%20with%20round%20table%20and%20tea%20cups%2C%20soft%20hanging%20lamp%20glow%2C%20empty%20chairs%20after%20a%20meeting%2C%20editorial%20cinematic%20photography%2C%20warm%20amber%20and%20cream%20tones%2C%20intimate%20secretive%20atmosphere%2C%20no%20people&width=1200&height=800&seq=art-dinner&orientation=landscape",
    tags: ["应酬", "圈内", "人情"],
    views: 147832,
    likes: 11220,
    hot: true,
    featured: false,
    blocks: [
      { type: "p", text: "有一类圈内真相，只出现在应酬桌上的三杯酒之后。那时候人会松口，会拍胸脯，会说出白天绝不会讲的真心话。可到了第二天，这些真话就像从没存在过，谁都不会认账。我见过太多聪明人，把最重要的话留在这种注定不算数的场合里讲。" },
      { type: "p", text: "记得有次饭局，一位前辈半醉着把行业的来龙去脉讲得明明白白，把几个「不能碰的雷」也点得很透。我后来拿本子记了一夜，才发现那晚的每句话，都比某些公开场合的漂亮话值钱得多。只可惜，这些话不能写进任何报道，只能烂在我自己的笔记里。" },
      { type: "quote", text: "圈内的真话从来不少，只是大多不配拥有署名。真正听得懂的人，会把桌上的话当线索，把白纸黑字的合同当答案。", cite: "一位常年混迹饭局的资深从业者" },
      { type: "p", text: "所以作为知情者，我从不建议圈外人把饭局传闻当真相。明星八卦圈内的消息，至少要在三个不同场合被不同人提起，才勉强能当「线索」听。这大概就是这个圈子最真实、也最暧昧的地方——话是真的，可一旦散场，就谁也不肯认了。" },
    ],
  },
  {
    slug: "shangwu-baojiadan-hou-mian-de-xiao-zi",
    title: "商务报价单背后，那排不起眼的小字",
    excerpt:
      "报价单上的大数字是给外人看的，底下那排关于档期、周期与平台的备注小字，才是圈内人真正较劲的地方。",
    category: "zhiqing",
    sourceRole: "商务知情者",
    date: "2026-09-02",
    readTime: "7 分钟",
    image:
      "https://readdy.ai/api/search-image?query=Business%20invoice%20and%20calculator%20on%20a%20warm%20oak%20desk%20with%20glasses%2C%20soft%20warm%20lighting%2C%20editorial%20close%20up%20photography%2C%20amber%20and%20cream%20tones%2C%20subtle%20shadows%2C%20no%20people&width=1200&height=800&seq=art-invoice&orientation=landscape",
    tags: ["商务", "报价", "业内"],
    views: 48677,
    likes: 3719,
    hot: false,
    featured: false,
    blocks: [
      { type: "p", text: "看过真正商务报价单的人会知道，决定一单能不能成的，往往不是那个醒目的数字，而是底部密密麻麻的备注小字。档期是否可调、配合哪些宣传、归谁统筹、含不含差旅——这排小字才是双方真正来回拉锯的地方。" },
      { type: "p", text: "有经验的商务，会把大数字谈得漂亮，把心思全花在小字上。因为数字谈崩了还可以再聊，小字没咬住，后续无数个坑等着你踩。圈内人常说「报价看人品」，其实就是看你在小字上是不是也守规矩。" },
      { type: "quote", text: "很多圈内的争执，表面看是钱，实际是小字背后的预期没对齐。能把小字讲明白的人，合作往往最省心。", cite: "一位品牌向的商务对接人" },
      { type: "tip", text: "无论你是甲方还是乙方，记住一条：越重要的合作，越要把丑话和小字都写在纸面上。白纸黑字，才是圈内唯一可靠的安全感。" },
    ],
  },
  {
    slug: "chuan-bo-dian-xin-ban",
    title: "通告单里的一行备注，藏着剧组的默契",
    excerpt:
      "开工时间、集合地点之外，通告单最下面常有一行没人解释的备注。老手一看就懂，新人却常踩坑。",
    category: "juzu",
    sourceRole: "剧组统筹",
    date: "2026-09-01",
    readTime: "5 分钟",
    image:
      "https://readdy.ai/api/search-image?query=A%20clipboard%20with%20a%20call%20sheet%20held%20near%20a%20walkie%20talkie%20on%20a%20warm%20film%20set%20chair%2C%20morning%20light%20through%20tent%2C%20editorial%20documentary%20photography%2C%20warm%20amber%20and%20cream%20tones%2C%20no%20people&width=1200&height=800&seq=art-calltime&orientation=landscape",
    tags: ["通告单", "统筹", "默契"],
    views: 39821,
    likes: 3022,
    hot: false,
    featured: false,
    blocks: [
      { type: "p", text: "剧组的「通告单」每天都会发，上面写着次日几点集合、拍哪几场、需要哪些演员。可真正的行家看通告，看的是最下面那行不起眼的备注——比如「当日天气变化较大，请各演员自备外套」这种话，翻译过来通常是「明天这场可能要等很久，别指望准点收工」。" },
      { type: "p", text: "这种「话里有话」的备注，是剧组多年磨合出来的默契，不会有人当面讲透，全靠你自己悟。新人第一天看不懂，往往就要吃「等太久却没准备」的亏。时间久了你就知道，通告单其实是一封写得很含蓄的家书，读懂了，你在组里就能少受很多累。" },
      { type: "quote", text: "剧组里真正的门道，从不写在明面上。能读懂那一行备注的人，才算是真的入了行。", cite: "一位跟过数个大组的现场统筹" },
      { type: "p", text: "很多人对明星八卦圈内的好奇，停留在热搜上的热闹。可你若真想看懂这个圈子，不妨先从一张通告单读起——那里面写着的，才是剧组工作人员日复一日的真实秩序与分寸。" },
    ],
  },
];

export const getArticle = (slug: string) =>
  ARTICLES.find((a) => a.slug === slug);

export const articlesByCategory = (key: string) =>
  ARTICLES.filter((a) => a.category === key);

export const getHot = (n = 8) =>
  [...ARTICLES].filter((a) => a.hot).slice(0, n);

export const getByViews = (n = 8) =>
  [...ARTICLES].sort((a, b) => b.views - a.views).slice(0, n);